import 'bootstrap/dist/css/bootstrap.min.css';
import React from "react"
import { useLocation, useNavigate } from "react-router-dom";
import { NavbarData } from "./NavbarData.js"
import { ThemeToggle } from "../../features/clips/components/ThemeToggle";
import { useClipTheme } from "../../features/clips/hooks/useClipTheme";
import './Navbar.css';

export default function Navbar() {
  
  let navigate = useNavigate();
  const location = useLocation();
  const { theme, toggleTheme } = useClipTheme();

  if (location.pathname.toLowerCase().startsWith("/clips")) return null;

  return (
    <div className="Navbar-Main">
      <table>
        <tbody>
          <tr>
            {NavbarData.map((item, key) => (
              <td key={key}>
                <button className="btn2" onClick={() => navigate(item.path)} aria-label={item.title} title={item.title}>
                  {item.icon}
                </button>
              </td>
            ))}
            
          </tr>
        </tbody>
      </table>
      {location.pathname === "/" && (
        <div className="navbar-theme-control">
          <ThemeToggle theme={theme} onToggle={toggleTheme} />
        </div>
      )}
    </div>
  );
}
